// Phase 9 — Onboarding tour completion flag, kept per-browser in
// localStorage. Same shape as `lib/reviewerIdentity.ts`. Not security-
// critical; clearing localStorage just re-fires the tour on next visit,
// which is acceptable.

const KEY = "clarity_onboarding_completed";

export function readOnboardingComplete(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function writeOnboardingComplete(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // Private-mode Safari etc — fail silent; the tour will fire again
    // on the next visit. Acceptable, not security-critical.
  }
}

export function clearOnboardingComplete(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
